import { initDrawers } from '../components/flowbite/drawer';
import { StockEvents } from '../events';
import { parseTextToHtml } from '../utils';
import '../../image/404/32/car.svg';
import '../../image/404/32/van.svg';
import '../../image/404/32/tractor.svg';
import '../../image/404/43/car.svg';
import '../../image/404/43/van.svg';
import '../../image/404/43/tractor.svg';
import '../../image/404/169/car.svg';
import '../../image/404/169/van.svg';
import '../../image/404/169/tractor.svg';
import '../../image/nap.svg';

((doc) => {
    const submitParentForm = (e) => {
        const form = e.target.closest('form');

        try {
            form.requestSubmit();
        } catch (e) {
            console.error('The requestSubmit method is not supported. Fallback to regular form submit.', e);
            form.submit();
        }
    };

    const bindEventsToFilterContainerAndElements = (doc) => {
        const root = doc.querySelector('#stock-filter-navigation');

        if (!root) {
            return;
        }

        for (const elem of root.querySelectorAll('button[type=submit]')) {
            // We disable the submit button click event for visitors with JS enabled.
            elem.addEventListener('click', (e) => {
                e.preventDefault();
                return false;
            });
        }

        const submitFormInTheBackgroundWrapper = async (e) => {
            await submitFormInTheBackground(doc, e);
        };

        for (const form of doc.querySelectorAll('.vehicle-filter-form')) {
            form.removeEventListener('change', submitParentForm);
            form.removeEventListener('submit', submitFormInTheBackgroundWrapper);
            form.addEventListener('change', submitParentForm, {
                once: true,
            });
            form.addEventListener('submit', submitFormInTheBackgroundWrapper, {
                once: true,
            });
        }
    };

    const limitFilterOptions = (doc) => {
        const filters = doc.querySelectorAll('[data-filter]');

        for (const filter of filters) {
            const name = filter.dataset.filter;
            const options = filter.querySelectorAll(`[data-for-filter="${name}"]`);

            const highestCountValues = [];
            for (const option of options) {
                const value = Number.parseInt(option.dataset.optionCount);

                if (highestCountValues.length < 5) {
                    highestCountValues.push(value);
                } else {
                    const compare = highestCountValues.shift();
                    if (compare < value) {
                        highestCountValues.push(value);
                    } else {
                        highestCountValues.push(compare);
                    }
                }

                highestCountValues.sort((a, b) => (a > b ? 1 : -1));
            }

            let hasHiddenOptions = false;
            for (const option of options) {
                const value = Number.parseInt(option.dataset.optionCount);

                if (!highestCountValues.includes(value)) {
                    if (option.querySelector('input[checked]') === null) {
                        option.hidden = true;
                        option.classList.add('hidden');
                        hasHiddenOptions = true;
                    }
                } else {
                    highestCountValues.splice(highestCountValues.indexOf(value), 1);
                }
            }

            if (hasHiddenOptions === true) {
                const showAll = document.createElement('button');
                showAll.innerText = 'Toon meer';
                showAll.classList.add('text-theme-secondary');
                showAll.addEventListener('click', (e) => {
                    e.preventDefault();
                    for (const option of options) {
                        option.hidden = false;
                        option.classList.remove('hidden');
                    }

                    showAll.hidden = true;
                    showAll.classList.add('hidden');
                });

                filter.append(showAll);
            }
        }
    };

    const submitFormInTheBackground = async (doc, e) => {
        e.preventDefault();

        const form = e.target;
        const target = e.submitter?.formAction || form.action;
        let formData = new FormData(e.target);

        // We are dealing with a possible override
        if (e.submitter) {
            formData = new FormData();
        }

        const url = new URL(target);
        const searchParams = new URLSearchParams(formData).toString();
        url.search = searchParams;
        const location = new URL(window.location.toString());
        location.search = searchParams;

        window.history.pushState({}, '', location);

        const loadingIndicator = doc.querySelector('#mobile-filter-loading-indicator');
        if (loadingIndicator !== null) {
            loadingIndicator.classList.remove('hidden');
        }

        const response = await fetch(url, {
            method: form.method,
        });

        if (!response.ok) {
            console.error(`Network response was not ok: ${response.status} ${response.statusText}. Trigger regular refresh.`);
            window.location.reload();
        }

        const repos = await response.text();
        const DOM = parseTextToHtml(repos);
        const selectors = ['#vehicle-container', '#stock-filter-navigation .stock-filter-header-title', '.vehicle-filter-form'];

        for (const selector of selectors) {
            const current = doc.querySelectorAll(selector);
            const target = DOM.querySelectorAll(selector);

            if (current.length !== target.length) {
                throw new Error(`The amount of elements for selector ${selector} is not the same.`);
            }

            current.forEach((element, pos) => {
                element.innerHTML = target[pos].innerHTML;
            });
        }

        window.dispatchEvent(
            new CustomEvent(StockEvents.LIST_PAGE_LOADED, {
                detail: {
                    document: doc,
                },
            }),
        );

        setTimeout(() => {
            if (loadingIndicator !== null) {
                loadingIndicator.classList.add('hidden');
            }
        }, 100);

        return false;
    };

    const listPageLoadedHandler = (e) => {
        const doc = e.detail.document;

        initDrawers(doc);
        bindEventsToFilterContainerAndElements(doc);
        limitFilterOptions(doc);
    };

    window.removeEventListener(StockEvents.LIST_PAGE_LOADED, listPageLoadedHandler);
    window.addEventListener(StockEvents.LIST_PAGE_LOADED, listPageLoadedHandler);

    if (!(doc instanceof ShadowRoot)) {
        window.dispatchEvent(
            new CustomEvent(StockEvents.LIST_PAGE_LOADED, {
                detail: {
                    document: doc,
                },
            }),
        );
    }
})(document.querySelector('[data-autowise-embed-container]')?.shadowRoot || document);
